// extracted by mini-css-extract-plugin
export default {"MONTH":"z6ChLV","month":"z6ChLV","DAY":"vvm3Sv","day":"vvm3Sv","YEAR":"dlXXHX","year":"dlXXHX","fields":"eSbrPf","mobile":"rG4vcm"};